import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import cfsReducer from '../screens/CallForSpeakers/reducers/CFSReducer';
import speakersReducer from '../screens/Speakers/reducers/speakersReducer';
import programReducer from '../screens/Program/reducers/programReducer';
import workshopsReducer from '../screens/Workshops/reducers/workshopsReducer';
import feedbackFormReducer from '../screens/FeedbackForm/reducers/feedbackFormReducer';
import feedbackFormWsReducer from '../screens/FeedbackFormWorkshop/reducers/feedbackFormWsReducer';

export default combineReducers({
    cfs: cfsReducer,
    speakers: speakersReducer,
    program: programReducer,
    workshops: workshopsReducer,
    feedbackForm: feedbackFormReducer,
    feedbackFormWs: feedbackFormWsReducer,
    router
});
